import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/export-pdf.png'


const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = { class: "reports-header" }
const _hoisted_3 = { class: "subtitle-main" }
const _hoisted_4 = { class: "card reports-select" }
const _hoisted_5 = {
  class: "dropdown-button input-dropdown",
  type: "button"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "centered-content" }
const _hoisted_8 = { class: "date-picker-container" }
const _hoisted_9 = { class: "date-picker-container" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "reports-container"
}
const _hoisted_12 = { class: "reports-wr-referrer" }
const _hoisted_13 = { class: "reports-wr-holds" }
const _hoisted_14 = { class: "reports-wr-buyer-types" }
const _hoisted_15 = { class: "reports-wr-buyer-types" }
const _hoisted_16 = { class: "reports-wr-lot-status-count" }
const _hoisted_17 = { class: "reports-wr-lot-status-price" }
const _hoisted_18 = { class: "reports-wr-lots-clicked" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["wr-reports-view", { 'wrapper-sidebar-open-report': $props.isActiveBurger }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "title-main" }, "Reports", -1)),
          _createElementVNode("h3", _hoisted_3, "Today is " + _toDisplayString($setup.formatDateToday($setup.today)), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
            control: _withCtx(() => [
              _createElementVNode("label", _hoisted_5, _toDisplayString($setup.estateSelected), 1)
            ]),
            dropdown: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.optionsEstate, (optionSelected) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: optionSelected,
                    onClick: ($event: any) => ($setup.onSelectEstate(optionSelected)),
                    class: _normalizeClass({ 'dropdown__item-active': optionSelected === $setup.estateSelected })
                  }, _toDisplayString(optionSelected), 11, _hoisted_6))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "label-text-select-day" }, "From", -1)),
              _createVNode($setup["DatePicker"], {
                modelValue: $setup.startDate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.startDate) = $event)),
                min: $setup.ANALYTICS_REPORT_MIN_DATE,
                disabled: $setup.loading,
                position: 'bottom left'
              }, null, 8, ["modelValue", "min", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "label-text-select-day" }, "To", -1)),
              _createVNode($setup["DatePicker"], {
                modelValue: $setup.endDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.endDate) = $event)),
                min: $setup.minEndDate,
                disabled: $setup.loading,
                position: 'bottom left'
              }, null, 8, ["modelValue", "min", "disabled"])
            ]),
            _createElementVNode("button", {
              class: "button default primary",
              onClick: $setup.searchReports,
              disabled: !$setup.startDate || !$setup.endDate || $setup.loading
            }, "Search", 8, _hoisted_10)
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "right-content" }, [
            _createElementVNode("button", { class: "button default primary" }, [
              _createTextVNode("Export"),
              _createElementVNode("img", {
                class: "export-btn",
                src: _imports_0
              })
            ])
          ], -1))
        ]),
        ($setup.showReports)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode($setup["ReferrerFromAnalytics"], {
                  startDate: $setup.startDate,
                  endDate: $setup.endDate,
                  searchKey: $setup.searchKey,
                  estateSelected: $setup.estateSelected
                }, null, 8, ["startDate", "endDate", "searchKey", "estateSelected"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode($setup["Holds"], {
                  startDate: $setup.startDate,
                  endDate: $setup.endDate,
                  searchKey: $setup.searchKey,
                  estateSelected: $setup.estateSelected
                }, null, 8, ["startDate", "endDate", "searchKey", "estateSelected"]),
                _createVNode($setup["HoldsCancelled"], {
                  startDate: $setup.startDate,
                  endDate: $setup.endDate,
                  searchKey: $setup.searchKey,
                  estateSelected: $setup.estateSelected
                }, null, 8, ["startDate", "endDate", "searchKey", "estateSelected"])
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "reports-wr-conversion-rates" }, null, -1)),
              _createVNode($setup["ConversionLeads"], {
                startDate: $setup.startDate,
                endDate: $setup.endDate,
                searchKey: $setup.searchKey,
                estateSelected: $setup.estateSelected
              }, null, 8, ["startDate", "endDate", "searchKey", "estateSelected"]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode($setup["BuyerType"], {
                  startDate: $setup.startDate,
                  endDate: $setup.endDate,
                  searchKey: $setup.searchKey,
                  estateSelected: $setup.estateSelected
                }, null, 8, ["startDate", "endDate", "searchKey", "estateSelected"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode($setup["BuyerLocation"], {
                  startDate: $setup.startDate,
                  endDate: $setup.endDate,
                  searchKey: $setup.searchKey,
                  estateSelected: $setup.estateSelected
                }, null, 8, ["startDate", "endDate", "searchKey", "estateSelected"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode($setup["LotStatusCount"], {
                  startDate: $setup.startDate,
                  endDate: $setup.endDate,
                  searchKey: $setup.searchKey,
                  estateSelected: $setup.estateSelected
                }, null, 8, ["startDate", "endDate", "searchKey", "estateSelected"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode($setup["LotStatusPrice"], {
                  startDate: $setup.startDate,
                  endDate: $setup.endDate,
                  searchKey: $setup.searchKey,
                  estateSelected: $setup.estateSelected
                }, null, 8, ["startDate", "endDate", "searchKey", "estateSelected"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode($setup["LotsOnClicksFromAnalytics"], {
                  startDate: $setup.startDate,
                  endDate: $setup.endDate,
                  searchKey: $setup.searchKey,
                  estateSelected: $setup.estateSelected
                }, null, 8, ["startDate", "endDate", "searchKey", "estateSelected"])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2))
}